import { cancelOnSessionChange } from '../session-cancellation';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrganizationsService } from '@api/services/organizations.service';
import * as BillingHistoryActions from '../../actions/organizations/billing-history.actions';

@Injectable()
export class OrganizationsBillingHistoryEffects {
  loadBillingHistory$;

  constructor(
    private actions$: Actions,
    private organizationsService: OrganizationsService
  ) {
    this.loadBillingHistory$ = createEffect(() =>
      this.actions$.pipe(
        ofType(BillingHistoryActions.loadBillingHistory),
        mergeMap(({ organizationId, requestId, pageIndex, cursor, limit, skipCount }) =>
          this.organizationsService.organizationsGetBillingHistory({
            organizationId,
            page: pageIndex + 1,
            limit,
            skipCount,
            cursor
          }).pipe(
            map(response => BillingHistoryActions.loadBillingHistorySuccess({
              organizationId,
              requestId,
              pageIndex,
              cursor,
              limit,
              entries: (response.entries || []).map(entry => ({
                data: entry,
                loadedAt: new Date()
              })),
              total: response.total,
              nextCursor: response.nextCursor
            })),
            catchError(() => of(BillingHistoryActions.loadBillingHistoryFailure({
              organizationId,
              requestId,
              error: 'Unable to load billing events. Please try again.'
            }))),
            cancelOnSessionChange(this.actions$)
          )
        )
      )
    );
  }
}
